import { createApiCallActions } from '../../../common/store/generic.actions';
import { SourceModel } from './types';
import { ListItem } from '../typeahead/types';

export const sourceActions = {
  getById: createApiCallActions<SourceModel>('source', 'getById'),
  getList: createApiCallActions<ListItem[]>('source', 'getList'),
  add: createApiCallActions<SourceModel>('source', 'add'),
  update: createApiCallActions<SourceModel>('source', 'update'),
};

export type SourceAction = typeof sourceActions;
